export const ASSET_MANIFEST = {
  "about/office.jpg": "site/about/office.ee7575efb7.jpg",
  "ascii/conference.png": "site/ascii/conference.e01a1c8d86.png",
  "ascii/lecture.png": "site/ascii/lecture.4bb1881208.png",
  "ascii/meeting.png": "site/ascii/meeting.66c5f2e7b1.png",
  "ascii/pitch.png": "site/ascii/pitch.01f685c98c.png",
  "ascii/workshop.png": "site/ascii/workshop.9d6ca2ca9d.png",
  "contact/contact.jpg": "site/contact/contact.e4472d3cd4.jpg",
  "corporate-social-responsibility/csr2.jpg": "site/corporate-social-responsibility/csr2.02c6d22104.jpg",
  "dev/pres_preview.png": "site/dev/pres_preview.5c359b09be.png",
  "enterprise/enterprise.jpg": "site/enterprise/enterprise.6a15a772b5.jpg",
  "file.svg": "site/file.2b67812c32.svg",
  "globe.svg": "site/globe.b614b9bf18.svg",
  "homepage/advanced_presentation.jpg": "site/homepage/advanced_presentation.ecf3bf893b.jpg",
  "homepage/analytics/analytics.png": "site/homepage/analytics/analytics.ea49389e8b.png",
  "homepage/cta/cta.png": "site/homepage/cta/cta.037153b65a.png",
  "homepage/dashboard/handyout_dashboard.png": "site/homepage/dashboard/handyout_dashboard.0aedb0c433.png",
  "homepage/forget.jpg": "site/homepage/forget.1c606deebe.jpg",
  "homepage/handyout_presenting.png": "site/homepage/handyout_presenting.f9b382f334.png",
  "homepage/handyout_scanned.png": "site/homepage/handyout_scanned.a174e5d77c.png",
  "homepage/languages/languages.png": "site/homepage/languages/languages.bfa4c86c0f.png",
  "homepage/livedemo/flathandholdingphone.png": "site/homepage/livedemo/flathandholdingphone.1cbe273fca.png",
  "homepage/modules/rise-invention.png": "site/homepage/modules/rise-invention.ff2c3f59f7.png",
  "homepage/qr/qr-dashboard.png": "site/homepage/qr/qr-dashboard.e047530d44.png",
  "homepage/tablet/slide-01.svg": "site/homepage/tablet/slide-01.3a80e80bdb.svg",
  "homepage/tablet/slide-02.svg": "site/homepage/tablet/slide-02.b32f4cce67.svg",
  "homepage/tablet/slide-03.svg": "site/homepage/tablet/slide-03.5d0b7a14c9.svg",
  "homepage/tablet/slide-04.svg": "site/homepage/tablet/slide-04.67b8526859.svg",
  "homepage/testimonials/celine.jpg": "site/homepage/testimonials/celine.019c564539.jpg",
  "homepage/testimonials/richard.jpg": "site/homepage/testimonials/richard.fbf1039422.jpg",
  "homepage/testimonials/zhang.jpg": "site/homepage/testimonials/zhang.303ecf0784.jpg",
  "homepage/trust/comments.png": "site/homepage/trust/comments.27262e9e9c.png",
  "homepage/trust/deep_analytics.png": "site/homepage/trust/deep_analytics.a0e3e998cc.png",
  "homepage/trust/eu_flag.jpg": "site/homepage/trust/eu_flag.ef0d7a9d9a.jpg",
  "industries/business.jpg": "site/industries/business.f921be6a9d.jpg",
  "industries/conference.jpg": "site/industries/conference.768b8ebc5c.jpg",
  "industries/education-hall.jpg": "site/industries/education-hall.faaaa870a7.jpg",
  "industries/education.jpg": "site/industries/education.c594f57728.jpg",
  "industries/medical.jpg": "site/industries/medical.c7e87fb193.jpg",
  "logo/logo_placeholder.png": "site/logo/logo_placeholder.3c776914b7.png",
  "logo/logo_white.svg": "site/logo/logo_white.499db21875.svg",
  "logos/powerpoint.svg": "site/logos/powerpoint.4d47b74860.svg",
  "mockups/es.png": "site/mockups/es.4662be2ab6.png",
  "mockups/hand-side-bg.png": "site/mockups/hand-side-bg.67bc33944b.png",
  "mockups/hand-side.png": "site/mockups/hand-side.4453312943.png",
  "mockups/mws.png": "site/mockups/mws.f9d9e54201.png",
  "mockups/tpm.png": "site/mockups/tpm.61a81ab502.png",
  "models/talking.glb": "site/models/talking.37d0a015eb.glb",
  "next.svg": "site/next.55995dfad6.svg",
  "presentation/bl.png": "site/presentation/bl.ea71ada9e7.png",
  "presentation/br.png": "site/presentation/br.901fb018e6.png",
  "presentation/presprev.png": "site/presentation/presprev.b174101945.png",
  "presentation/prevprese.png": "site/presentation/prevprese.6e8acfb772.png",
  "presentation/tl.png": "site/presentation/tl.11f45bc7dd.png",
  "presentation/tr.png": "site/presentation/tr.f78ef4efe1.png",
  "profiles/profile_placeholder.png": "site/profiles/profile_placeholder.8f00f9e041.png",
  "qr-code-placeholder-colored.svg": "site/qr-code-placeholder-colored.02fb3303f8.svg",
  "qr-code-placeholder.svg": "site/qr-code-placeholder.d19b275b69.svg",
  "qr/aud.png": "site/qr/aud.2ce8533778.png",
  "qr/handyout_logo_qr.svg": "site/qr/handyout_logo_qr.829015b155.svg",
  "qr/stage.png": "site/qr/stage.e7dbbdf20b.png",
  "qr/stage_aud.png": "site/qr/stage_aud.9744d72c20.png",
  "quotes/quote-left-outline.svg": "site/quotes/quote-left-outline.ef7cffd92c.svg",
  "quotes/quote-left.svg": "site/quotes/quote-left.b3af1f6d1c.svg",
  "quotes/quote-right-outline.svg": "site/quotes/quote-right-outline.78c5ca95cb.svg",
  "quotes/quote-right.svg": "site/quotes/quote-right.6ad40dd065.svg",
  "quotes/quote-together.svg": "site/quotes/quote-together.b45eb0828d.svg",
  "referral/referral_homepage_img.jpg": "site/referral/referral_homepage_img.9be154b017.jpg",
  "referral/referral_img.jpg": "site/referral/referral_img.f2b94abe6a.jpg",
  "signin/login.png": "site/signin/login.8295c39392.png",
  "signin/signin.jpg": "site/signin/signin.a9ebfeebdb.jpg",
  "sustainability/sus1.jpg": "site/sustainability/sus1.ce990bd74a.jpg",
  "sustainability/sus2.jpg": "site/sustainability/sus2.7c285e37cc.jpg",
  "sustainability/sus3.jpg": "site/sustainability/sus3.a4aeeba253.jpg",
  "sustainability/sus4.jpg": "site/sustainability/sus4.74698b4486.jpg",
  "sustainability/sus5.jpg": "site/sustainability/sus5.a4fdf79887.jpg",
  "testimonials/bh.png": "site/testimonials/bh.114068f34f.png",
  "testimonials/dh.jpg": "site/testimonials/dh.a0df9d0799.jpg",
  "testimonials/nh.jpg": "site/testimonials/nh.78e5ee9501.jpg",
  "vercel.svg": "site/vercel.f081337b2f.svg",
  "videos/canada.mp4": "site/videos/canada.3bcfdb6191.mp4",
  "videos/celine_vid.mp4": "site/videos/celine_vid.a408d23e7b.mp4",
  "videos/conference.mp4": "site/videos/conference.c54517c164.mp4",
  "videos/qrcodevideo.mp4": "site/videos/qrcodevideo.94bc20522b.mp4",
  "videos/richard_vid.mp4": "site/videos/richard_vid.d590ce2f3b.mp4",
  "videos/tutorials/creation.mp4": "site/videos/tutorials/creation.f89749982d.mp4",
  "videos/tutorials/upload.mp4": "site/videos/tutorials/upload.36cdb91f1c.mp4",
  "videos/zhang_vid.mp4": "site/videos/zhang_vid.f23313d7c2.mp4",
  "videos/zoom-parallax/shutterstock_3737760667.mp4": "site/videos/zoom-parallax/shutterstock_3737760667.36a16b1ddc.mp4",
  "videos/zoom-parallax/shutterstock_3737760667.webm": "site/videos/zoom-parallax/shutterstock_3737760667.1b01695fe0.webm",
  "videos/zoom-parallax/shutterstock_3961373497.mp4": "site/videos/zoom-parallax/shutterstock_3961373497.8134d198b3.mp4",
  "videos/zoom-parallax/shutterstock_3961373497.webm": "site/videos/zoom-parallax/shutterstock_3961373497.55c90acc78.webm",
  "videos/zoom-parallax/shutterstock_3988889565.mp4": "site/videos/zoom-parallax/shutterstock_3988889565.ed6570c6c2.mp4",
  "videos/zoom-parallax/shutterstock_3988889565.webm": "site/videos/zoom-parallax/shutterstock_3988889565.b0b84e3bec.webm",
  "videos/zoom-parallax/shutterstock_4045685143.mp4": "site/videos/zoom-parallax/shutterstock_4045685143.565d619c68.mp4",
  "videos/zoom-parallax/shutterstock_4045685143.webm": "site/videos/zoom-parallax/shutterstock_4045685143.a39abc37eb.webm",
  "videos/zoom-parallax/shutterstock_4046990495.mp4": "site/videos/zoom-parallax/shutterstock_4046990495.93d4535987.mp4",
  "videos/zoom-parallax/shutterstock_4046990495.webm": "site/videos/zoom-parallax/shutterstock_4046990495.143278d29b.webm",
  "videos/zoom-parallax/shutterstock_4069446759.mp4": "site/videos/zoom-parallax/shutterstock_4069446759.53c1b1e80d.mp4",
  "videos/zoom-parallax/shutterstock_4069446759.webm": "site/videos/zoom-parallax/shutterstock_4069446759.7b1de09a1e.webm",
  "window.svg": "site/window.644768c4aa.svg",
} as const;

export type AssetPath = keyof typeof ASSET_MANIFEST;
